var map = {
	"./BuyTrainTickets/1.mp3": 1788,
	"./BuyTrainTickets/10.mp3": 268,
	"./BuyTrainTickets/11.mp3": 8129,
	"./BuyTrainTickets/12.mp3": 6142,
	"./BuyTrainTickets/13.mp3": 8083,
	"./BuyTrainTickets/14.mp3": 6208,
	"./BuyTrainTickets/15.mp3": 3301,
	"./BuyTrainTickets/16.mp3": 8770,
	"./BuyTrainTickets/17.mp3": 8660,
	"./BuyTrainTickets/18.mp3": 3898,
	"./BuyTrainTickets/19.mp3": 5481,
	"./BuyTrainTickets/2.mp3": 2163,
	"./BuyTrainTickets/20.mp3": 6169,
	"./BuyTrainTickets/21.mp3": 1220,
	"./BuyTrainTickets/22.mp3": 7499,
	"./BuyTrainTickets/3.mp3": 3918,
	"./BuyTrainTickets/4.mp3": 9797,
	"./BuyTrainTickets/5.mp3": 4080,
	"./BuyTrainTickets/6.mp3": 1652,
	"./BuyTrainTickets/7.mp3": 2226,
	"./BuyTrainTickets/8.mp3": 985,
	"./BuyTrainTickets/9.mp3": 6036,
	"./BuyTrainTickets/index.mp3": 1229,
	"./bookHotel/1.mp3": 1862,
	"./bookHotel/10.mp3": 298,
	"./bookHotel/11.mp3": 3263,
	"./bookHotel/12.mp3": 2120,
	"./bookHotel/13.mp3": 3197,
	"./bookHotel/14.mp3": 5574,
	"./bookHotel/15.mp3": 4955,
	"./bookHotel/16.mp3": 516,
	"./bookHotel/17.mp3": 7529,
	"./bookHotel/18.mp3": 7378,
	"./bookHotel/19.mp3": 4423,
	"./bookHotel/2.mp3": 1289,
	"./bookHotel/20.mp3": 5387,
	"./bookHotel/21.mp3": 9062,
	"./bookHotel/3.mp3": 7300,
	"./bookHotel/4.mp3": 3199,
	"./bookHotel/5.mp3": 9610,
	"./bookHotel/6.mp3": 9485,
	"./bookHotel/7.mp3": 9528,
	"./bookHotel/8.mp3": 451,
	"./bookHotel/9.mp3": 3598,
	"./bookHotel/index.mp3": 7611,
	"./evaluation/10.mp3": 5311,
	"./evaluation/11.mp3": 6346,
	"./evaluation/12.mp3": 4717,
	"./evaluation/13.mp3": 56,
	"./evaluation/17.mp3": 9476,
	"./evaluation/18.mp3": 6359,
	"./evaluation/19.mp3": 9314,
	"./evaluation/2.mp3": 2562,
	"./evaluation/20.mp3": 8462,
	"./evaluation/21.mp3": 8963,
	"./evaluation/22.mp3": 3980,
	"./evaluation/23.mp3": 4401,
	"./evaluation/24.mp3": 1554,
	"./evaluation/25.mp3": 6071,
	"./evaluation/26.mp3": 1824,
	"./evaluation/27.mp3": 2101,
	"./evaluation/28.mp3": 374,
	"./evaluation/29.mp3": 9131,
	"./evaluation/30.mp3": 965,
	"./evaluation/31.mp3": 4336,
	"./evaluation/32.mp3": 9271,
	"./evaluation/33.mp3": 4338,
	"./evaluation/34.mp3": 4145,
	"./evaluation/35.mp3": 6284,
	"./evaluation/36.mp3": 99,
	"./evaluation/37.mp3": 1710,
	"./evaluation/38.mp3": 157,
	"./evaluation/39.mp3": 7640,
	"./evaluation/40.mp3": 5948,
	"./evaluation/41.mp3": 3809,
	"./evaluation/42.mp3": 1374,
	"./evaluation/43.mp3": 9763,
	"./evaluation/44.mp3": 4000,
	"./evaluation/45.mp3": 3010,
	"./evaluation/46.mp3": 4002,
	"./evaluation/47.mp3": 8935,
	"./evaluation/48.mp3": 6868,
	"./evaluation/49.mp3": 9065,
	"./evaluation/5.mp3": 5409,
	"./evaluation/50.mp3": 67,
	"./evaluation/51.mp3": 1822,
	"./evaluation/52.mp3": 5617,
	"./evaluation/53.mp3": 7935,
	"./evaluation/7.mp3": 9971,
	"./evaluation/8.mp3": 5400,
	"./evaluation/9.mp3": 9005,
	"./voiceCall/1.mp3": 1187,
	"./voiceCall/2.mp3": 3372,
	"./voiceCall/3.mp3": 1233,
	"./voiceCall/4.mp3": 1874,
	"./voiceCall/5.mp3": 9383,
	"./voiceCall/6.mp3": 9312,
	"./voiceCall/7.mp3": 6405,
	"./voiceCall/8.mp3": 2662,
	"./voiceCall/index.mp3": 4686
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3961;